import { Text, TogglableChips, VerticalSpacer } from "@innovationnorway/lighthouse-components";
import React, { useEffect, useState } from "react";
import { FetchStatus } from "../../../main/models/fetch-status";
import { UserTask } from "../../../main/models/user-task";
import { useLayout } from "../../hooks/useLayout";
import TimedImage from "../easter/easter";
import { InfoBanner } from "../infoBanner/infoBanner";
import NotificationList from "../notificationList/notificationList";
import "./myTasks.scss";

interface MyTasksProps {
  tasks?: UserTask[];
  newTasks?: UserTask[];
  projectTitle: string;
  fetchStatus?: FetchStatus;
}

enum ChipsEnum {
  New = "new",
  All = "all"
}

const MyTasks = ({ tasks, projectTitle, newTasks, fetchStatus }: MyTasksProps) => {
  const { translations } = useLayout();
  const [showEaster, setShowEaster] = useState(false);
  const [selectedChip, setSelectedChip] = useState<ChipsEnum>(
    newTasks && newTasks?.length > 0 ? ChipsEnum.New : ChipsEnum.All
  );

  useEffect(() => {
    setSelectedChip(newTasks && newTasks?.length > 0 ? ChipsEnum.New : ChipsEnum.All);
  }, [newTasks]);

  return (
    <div className="myTasks">
      <Text className="data-hj-suppress" variant="lead2">
        {translations.myTasks} {projectTitle}
      </Text>
      <VerticalSpacer size="m" />
      {fetchStatus === FetchStatus.TasksFailed && tasks?.length === 0 ? (
        <InfoBanner variant="error">
          <Text>
            {translations.couldNotFetchTasksError} {translations.generalErrorContactSupport}
          </Text>
        </InfoBanner>
      ) : (
        fetchStatus === FetchStatus.TasksFailed && (
          <>
            <InfoBanner variant="error">
              <Text>
                {translations.couldNotFetchAllTasksError} {translations.generalErrorContactSupport}
              </Text>
            </InfoBanner>
            <VerticalSpacer size="m" />
          </>
        )
      )}
      {tasks && tasks?.length > 0 ? (
        <>
          <div style={{ display: "flex", flexDirection: "row" }}>
            {newTasks && newTasks?.length > 0 && (
              <TogglableChips
                selected={selectedChip === ChipsEnum.New}
                style={{ marginRight: "10px" }}
                onClick={() => setSelectedChip(ChipsEnum.New)}
              >
                {translations.newTasks}
              </TogglableChips>
            )}

            <TogglableChips selected={selectedChip === ChipsEnum.All} onClick={() => setSelectedChip(ChipsEnum.All)}>
              {translations.allTasks}
            </TogglableChips>
          </div>
          <VerticalSpacer size="m" />
          {selectedChip === ChipsEnum.New ? (
            <NotificationList tasks={newTasks} hideProjectInfo />
          ) : (
            <NotificationList tasks={tasks} hideProjectInfo />
          )}
        </>
      ) : (
        fetchStatus == FetchStatus.Ok && (
          <>
            <InfoBanner variant="success" onClick={() => setShowEaster(true)}>
              <Text as="span">{translations.noTasks}</Text>
            </InfoBanner>
            <TimedImage isVisible={showEaster} setIsVisible={setShowEaster} />
          </>
        )
      )}
    </div>
  );
};

export default MyTasks;
